import { useStoreActions } from '../store';

interface ConvivaProviderProps {
  children: any;
}

export function ConvivaProvider(props: ConvivaProviderProps) {
  const convivaActions = useStoreActions(actions => actions.conviva);

  /**
   * Initialize Conviva SDK and analytics instance.
   */
  convivaActions.enable();

  return props.children;
}
